import { useMutation, useQueryClient } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { useActiveOrganization } from "@/hooks/organizations";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { displayErrorToast } from "@/utils/toast";
import { jsonAuthHeaders } from "@/utils/headers";
import { useRedirectToDefaultWorkspace } from "@/hooks/useRedirectToDefaultWorkspace";

export const useDeleteOrganization = () => {
  const auth = useAuth();
  const queryClient = useQueryClient();
  const redirectToDefaultWorkspace = useRedirectToDefaultWorkspace();
  const { data: activeOrganization } = useActiveOrganization();

  return useMutation(
    (organizationId: number) =>
      fetch(`${ENDPOINTS.organizations}/${organizationId}`, {
        method: "DELETE",
        headers: jsonAuthHeaders(auth?.userToken ?? ""),
      }).then(res => {
        if (activeOrganization?.id === organizationId) {
          redirectToDefaultWorkspace(organizationId);
        }
        return handleResponse(res);
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([ENDPOINTS.organizations]);
      },
      onError: error => {
        displayErrorToast(error);
      },
    },
  );
};
